class SidebarNavigation {

    constructor(el, options) {
        this.el = el;
        this.init();
    }

    init() {
        // Hide all nested lists
        this.el.querySelectorAll('[data-ol]:not([data-root])').forEach((el) => {
            // Do not collapse list when there is an active item present
            if(!el.querySelector('[data-active]')) {
                // Collapse nested list
				$(el).addClass('t-hidden');

                // Rotate icon
				$(el.parentNode).find('a .c-icon').removeClass('c-icon--rotate-left');
				$(el.parentNode).find('a .c-icon').addClass('c-icon--rotate-right');
            }
        });

        // Toggle all nested lists on click
        this.el.querySelectorAll('[data-li]').forEach((el) => {
            el.addEventListener('click', function(e) {
                const ol = e.currentTarget.querySelector('[data-ol]');

                // Only toggle if there is a nested list
                if (ol) {
                    // Rotate icon
					$(e.currentTarget).find('[data-icon] .c-icon').toggleClass('c-icon--rotate-left');
					$(e.currentTarget).find('[data-icon] .c-icon').toggleClass('c-icon--rotate-right');

                    // Toggle nested list
					$(ol).toggleClass('t-hidden');

                    // Do not follow link
                    e.preventDefault();
                }

                // Do not bubble up
                e.stopPropagation();
            });
        });
    }
}

export { SidebarNavigation as SidebarNavigation };
